module.exports = __webpack_public_path__ + "img/web_dev_mesure_link.57bdbbee.png";